<script>
import ConversationCard from './widgets/conversation/ConversationCard.vue';
export default {
  components: {
    ConversationCard,
  },
  inject: [
    'selectConversation',
    'deSelectConversation',
    'selectConversationRange',
    'lastSelectedIndex',
    'conversationList',
    'assignAgent',
    'assignTeam',
    'assignLabels',
    'updateConversationStatus',
    'toggleContextMenu',
    'markAsUnread',
    'markAsRead',
    'assignPriority',
    'isConversationSelected',
    'deleteConversation',
    'restoreConversation',
  ],
  props: {
    source: {
      type: Object,
      required: true,
    },
    teamId: {
      type: [String, Number],
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    conversationType: {
      type: String,
      default: '',
    },
    foldersId: {
      type: [String, Number],
      default: 0,
    },
    priority: {
      type: String,
      default: '',
    },
    showAssignee: {
      type: Boolean,
      default: false,
    },
    itemIndex: {
      type: Number,
      default: null,
    },
  },
  methods: {
    handleSelectConversation(...args) {
      this.selectConversation(...args);
    },
    handleDeSelectConversation(...args) {
      this.deSelectConversation(...args);
    },
    handleSelectConversationRange(startIndex, endIndex) {
      this.selectConversationRange(startIndex, endIndex, this.conversationList);
    },
  },
};
</script>

<template>
  <ConversationCard
    :key="source.id"
    :active-label="label"
    :team-id="teamId"
    :folders-id="foldersId"
    :priority="priority"
    :chat="source"
    :conversation-type="conversationType"
    :selected="isConversationSelected(source.id)"
    :show-assignee="showAssignee"
    :item-index="itemIndex"
    enable-context-menu
    @select-conversation="handleSelectConversation"
    @de-select-conversation="handleDeSelectConversation"
    @select-conversation-range="handleSelectConversationRange"
    @assign-agent="assignAgent"
    @assign-team="assignTeam"
    @assign-label="assignLabels"
    @update-conversation-status="updateConversationStatus"
    @context-menu-toggle="toggleContextMenu"
    @mark-as-unread="markAsUnread"
    @mark-as-read="markAsRead"
    @assign-priority="assignPriority"
    @delete-conversation="deleteConversation"
    @restore-conversation="restoreConversation"
  />
</template>
